module.exports = __webpack_public_path__ + "static/media/premierOneLeftSeatMobileSelected.5861e117.svg";